import {retryUntil} from './timing.helpers';

export function retryUntilStylesAreLoaded(onStylesLoaded: () => void, timeoutMessage: string, documentContainer: Window = window): void {
  // This isn't completely reliable, but if our main stylesheet is loaded and applied, we probably/hopefully have what we need.  (See the end of styles.scss.)
  retryUntil(
    () => cssVariableValue('--hk-css-load-detector', documentContainer) === 'LOADED',
    onStylesLoaded,
    () => {
      throw new Error(timeoutMessage)
    }
  );
}

export function cssVariableValue(cssVariableName: string, documentContainer: Window = window): string {
  return getComputedStyle(documentContainer.document.documentElement).getPropertyValue(cssVariableName);
}

export function rgbColorFromCssVariable(cssColorVariableName: string, documentContainer: Window = window): string {
  return `rgb(${cssVariableValue(cssColorVariableName, documentContainer).split(' ').join(',')})`;
}

export function hexColorFromCssVariable(cssColorVariableName: string, documentContainer: Window = window): string {
  const hexValue: string =
    cssVariableValue(cssColorVariableName, documentContainer)
      .split(' ')
      .map(rgbValue => {
        const hex: string = Number(rgbValue).toString(16);

        return hex.length === 1 ? `0${hex}` : hex;
      })
      .join('');

  return `#${hexValue}`;
}

export function pixelValueFromCssVariable(cssSizeVariableName: string, documentContainer: Window = window): number {
  const variableValue: string = cssVariableValue(cssSizeVariableName, documentContainer);

  if (!/^[.\d]+rem$/.test(variableValue)) return 0;

  return parseFloat(variableValue) * 16;
}
